import { GET_FAMILIA, ADD_FAMILIA, MODIFY_FAMILIA, DELETE_FAMILIA, UPDATE_FAMILIA } from '../constants/action_types';

const initialState = {
    familias: [],
    isLoading: false
};

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_FAMILIA:
            
            return {
                ...state,
                isLoading: true
            };

        case GET_FAMILIA + "_SUCCESS":
            return {
                familias: action.payload.data,
                isLoading: false
            };

        case ADD_FAMILIA:
            
            const newArr = [...state.familias, action.payload]
            return {
                familias: newArr,
                isLoading: false
            };

        case MODIFY_FAMILIA:
            
            return {
                familias: state.familias.map((p) => {
                    if (p.id !== action.payload.id) 
                        return p;
                    else
                        return action.payload
                }),
                isLoading: false
            };

        case DELETE_FAMILIA:

            return {
                familias: state.familias.filter(p => p.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_FAMILIA + "_SUCCESS":

            return state;

        default:

            return state;
    }
}